import { useState, useEffect } from "react";
import { collection, query, orderBy, onSnapshot, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { Message } from "../types";

export function useMessages(roomCode: string | null) {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!roomCode) {
      setMessages([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Real-time listener for messages
      const messagesRef = collection(db, "blinkbli", "rooms", "rooms", roomCode, "messages");
      const q = query(messagesRef, orderBy("order", "asc"));

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const msgs: Message[] = [];
          snapshot.forEach((doc) => {
            const data = doc.data();
            msgs.push({
              id: doc.id,
              senderUid: data.senderUid,
              senderDeviceId: data.senderDeviceId,
              senderName: data.senderName,
              text: data.text,
              clientMessageId: data.clientMessageId,
              order: data.order,
              createdAt: data.createdAt instanceof Timestamp 
                ? data.createdAt.toDate().toISOString() 
                : data.createdAt,
              expiresAt: data.expiresAt instanceof Timestamp 
                ? data.expiresAt.toDate().toISOString() 
                : data.expiresAt,
            });
          });
          setMessages(msgs);
          setLoading(false);
        },
        (err) => {
          console.error("Error listening to messages:", err);
          setError(err.message);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (err: any) {
      console.error("Error setting up message listener:", err);
      setError(err.message);
      setLoading(false);
    }
  }, [roomCode]);

  return { messages, loading, error };
}

